"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Screw = void 0;
const BallScrewElement_1 = require("./BallScrewElement");
const Rows_1 = require("./Rows");
/**
 * Class to draw a screw
 */
class Screw extends BallScrewElement_1.BallScrewElement {
    constructor(two, width, height, internalHeight, selected, configuration) {
        super();
        this.two = two;
        this.width = width;
        this.height = height;
        this.selected = selected;
        this.internalHeight = internalHeight;
        this.configuration = configuration;
    }
    draw() {
        // Groups can take an array of shapes and/or groups.
        this.group = this.two.makeGroup();
        const threadGap = (this.height - this.internalHeight) / 2;
        this.rect = this.two.makeRectangle(this.width / 2, 0, this.width, this.height);
        let iso = "";
        if (this.configuration.precision != null && this.configuration.precision !== "") {
            iso = this.configuration.precision.name.substring(0, this.configuration.precision.name.indexOf("("));
        }
        if (this.configuration.configuration != null) {
            iso = this.configuration
                .configuration
                .precision
                .name
                .substring(0, this.configuration.configuration.precision.name.indexOf("("));
        }
        this.registerForQuote([this.rect], "outerleft", 1, "Ø " + parseFloat(this.selected.nominal_diameter.toString()).toFixed(0).toString() + "." + parseFloat(this.selected.lead.toString()).toFixed(0).toString() + " RH " + iso.trim());
        this.group.add(this.rect);
        let length = this.configuration != null ? this.configuration.screwLength : null;
        if ((length === undefined || length === null) && this.configuration.configuration != null) {
            length = this.configuration.configuration.screwLength;
        }
        if (!isNaN(length) && length > 0) {
            this.registerForQuote([this.rect], "bottom", 140, "THREAD LENGTH: " + length);
        }
        const realTop = this.height / 2;
        const topThread = Rows_1.Rows.draw(this.two, 0, -realTop + threadGap, this.width, -(realTop) + threadGap, Rows_1.RowsStyle.Thread);
        const bottomThread = Rows_1.Rows.draw(this.two, 0, realTop - threadGap, this.width, realTop - threadGap, Rows_1.RowsStyle.Thread);
        this.group.add(topThread);
        this.group.add(bottomThread);
        const dist = this.width / 25;
        const line = this.two.makeLine(this.width - dist, -realTop - 10, this.width - dist - 20, realTop + 10);
        line.linewidth = 1;
        line.stroke = "#000";
        line.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        this.group.add(line);
        const line2 = this.two.makeLine(this.width - dist + 10, -realTop - 10, this.width - dist - 10, realTop + 10);
        line2.linewidth = 1;
        line2.stroke = "#000";
        line2.dashes = Rows_1.Rows.getDashesForStyle(Rows_1.RowsStyle.Axis);
        this.group.add(line2);
        const line3 = this.two.makeLine(this.width - dist + 5, -realTop - 10, this.width - dist - 15, realTop + 10);
        line3.linewidth = 7;
        line3.stroke = "#fff";
        this.group.add(line3);
        return this.group;
    }
}
exports.Screw = Screw;
